import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";
import { apiV2 } from './api'

// 原始接口
export interface KnowledgeListFoldersResponse {
  total: number;
  list: KnowledgeFolder[];
  page: number;
  size: number;
};

export interface KnowledgeFolder {
  id: number;
  folder_uuid: string;
  parent_folder_id: number;
  user_id: number;
  folder_name: string;
  create_time: number;
  update_time: number;
  deleted_time?: string;
  item_count?: number;
};


// 请求接口
interface KnowledgeListFoldersRequest {
  page: number,
  pageSize: number
  userId?: string
  agentId?: string,
}

export class KnowledgeFolderData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Folder name cannot be empty")
  @IsString("Folder name must be a string")
  folderName: string;

  @Required("Create time cannot be empty")
  @IsNumber("Create time must be a number")
  createTime: number;

  @IsNumber("Item count must be a number")
  itemCount?: number;
}

export class KnowledgeListFoldersData {
  @IsArray("List must be an array")
  list: KnowledgeFolderData[];

  @Required("Total cannot be empty")
  @IsNumber("Total must be a number")
  total: number;

  @Required("Page cannot be empty")
  @IsNumber("Page must be a number")
  page: number;

  @Required("Page size cannot be empty")
  @IsNumber("Page size must be a number")
  size: number;
}

const transformAndValidateAgent = (
  response: KnowledgeListFoldersResponse
): KnowledgeListFoldersData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, KnowledgeListFoldersData);
  } catch (error) {
    console.error("Knowledge list folders data validation failed:", error.message); 
    throw error;
  }
};

/** 知识库文件夹列表 */
export const knowledgeListFolders = async ({
  page,
  pageSize,
  userId,
  agentId,
}: KnowledgeListFoldersRequest): Promise<KnowledgeListFoldersData> => {
  const response = await apiV2.post<KnowledgeListFoldersResponse>('/knowledge/list_folders', {
    page,
    page_size: pageSize,
    user_id: userId,
  }, {
    headers: {
      "X-Agent-Id": agentId,
    },
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
